import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SchemaOrg from '../../components/feature/SchemaOrg';
import MiniPriceSimulator from '../../components/feature/MiniPriceSimulator';

export default function LivraisonExpressParisPage() {
  useEffect(() => {
    document.title = "Livraison Express Paris | Transporteur Express IDF - Coursier, Utilitaire avec Chauffeur 24/7";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Transporteur Express IDF : livraison express Paris en 30 min, coursier moto, location camion utilitaire avec chauffeur, aide au déménagement et chargement. Service 24h/7j. Devis gratuit !');
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'livraison express Paris, transport express Paris, coursier express Paris, location camion utilitaire avec chauffeur Paris, aide au déménagement Paris, aide au chargement Paris, livraison urgente Paris, livraison 30 min Paris, coursier moto Paris, livreur express Paris, transport colis urgent Paris, livraison 24h Paris, coursier professionnel IDF, transporteur express Île-de-France, livraison rapide Paris');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://transporteurexpressidf.fr/livraison-express-paris');
    }
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', 'Livraison Express Paris | Transporteur Express IDF - Coursier, Utilitaire avec Chauffeur 24/7');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', 'Transporteur Express IDF : livraison express Paris en 30 min, coursier moto, location camion utilitaire avec chauffeur, aide au déménagement et chargement. Service 24h/7j.');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', 'https://transporteurexpressidf.fr/livraison-express-paris');
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', 'Livraison Express Paris | Transporteur Express IDF - Coursier, Utilitaire avec Chauffeur 24/7');
    const twitterDesc = document.querySelector('meta[name="twitter:description"]');
    if (twitterDesc) twitterDesc.setAttribute('content', 'Transporteur Express IDF : livraison express Paris en 30 min, coursier moto, location camion utilitaire avec chauffeur, aide au déménagement et chargement. Service 24h/7j.');
    const geoRegion = document.querySelector('meta[name="geo.region"]');
    if (geoRegion) geoRegion.setAttribute('content', 'FR-IDF');
    const geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (geoPlacename) geoPlacename.setAttribute('content', 'Paris, Île-de-France');
    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg type="livraison" />
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-orange-50 to-orange-100 py-20 pb-16">
          <div className="max-w-6xl mx-auto px-4">
            <div className="text-center mb-16">
              <h1 className="text-5xl font-black text-gray-900 mb-6 font-inter">
                Votre transporteur express de confiance à Paris
              </h1>
              <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                <strong>Transport express Paris</strong> en moins d'une heure garanti ! Notre service de <strong>livraison urgente</strong> couvre tout Paris et la petite couronne avec des <strong>coursiers professionnels</strong>. <strong>Speed Transport</strong> disponible 24h/24 et 7j/7 pour toutes vos urgences.
              </p>
              <div className="mt-8 text-sm text-gray-500">
                <p>Livraison express dans toute l'IDF : <a href="/transporteur-express-nanterre" className="text-orange-600 hover:underline">Express Nanterre</a>, <a href="/transporteur-palettes-rungis" className="text-orange-600 hover:underline">Palettes Rungis</a>, <a href="/livraison-urgente-evenementiel-villepinte" className="text-orange-600 hover:underline">Urgence Villepinte</a></p>
              </div>
            </div>
            
            <div className="text-center">
              <a 
                href="tel:+33632410246"
                className="inline-flex items-center px-8 py-4 bg-orange-600 text-white text-lg font-semibold rounded-full hover:bg-orange-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-rocket-line w-5 h-5 mr-3"></i>
                Livraison Immédiate +33 6 32 41 02 46
              </a>
            </div>
          </div>
        </section>

        {/* Mini Price Simulator */}
        <MiniPriceSimulator />

        {/* Types de Livraison */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Types de Livraison Express Paris
            </h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-rocket-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Livraison Express 30 Min</h3>
                <p className="text-gray-600 mb-4">
                  Livraison express Paris centre en 30 minutes chrono ! Service livraison rapide avec livreur moto pour vos colis urgents et prioritaires.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Livraison Paris 30 min</li>
                  <li>• Livreur moto rapide</li>
                  <li>• Colis jusqu'à 5kg</li>
                  <li>• Garantie express</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-timer-2-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Livraison Rapide 1H</h3>
                <p className="text-gray-600 mb-4">
                  Livraison rapide Paris et banlieue en 1 heure maximum. Service livraison express étendu pour couvrir toute l'Île-de-France rapidement.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Livraison Paris + banlieue</li>
                  <li>• Service 1 heure</li>
                  <li>• Tous types de colis</li>
                  <li>• Livreur professionnel</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-time-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Livraison Urgente 24/7</h3>
                <p className="text-gray-600 mb-4">
                  Livraison urgente Paris jour et nuit ! Service livraison express disponible 24h/24 pour toutes vos situations d'urgence absolue.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Service 24/7</li>
                  <li>• Livraison nuit</li>
                  <li>• Weekend inclus</li>
                  <li>• Urgence absolue</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-truck-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Livraison Utilitaire</h3>
                <p className="text-gray-600 mb-4">
                  Livraison utilitaire Paris pour gros colis et objets volumineux. Camionnette équipée avec livreur pour transport livraison express sécurisé.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Gros colis 50kg+</li>
                  <li>• Objets volumineux</li>
                  <li>• Camionnette équipée</li>
                  <li>• Transport sécurisé</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-building-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Livraison Entreprise</h3>
                <p className="text-gray-600 mb-4">
                  Livraison entreprise Paris professionnel. Service livraison express B2B avec facture, contrat entreprise et livreur dédié pour vos besoins pro.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Service B2B</li>
                  <li>• Facture entreprise</li>
                  <li>• Contrat pro</li>
                  <li>• Livreur dédié</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-shopping-bag-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Livraison E-commerce</h3>
                <p className="text-gray-600 mb-4">
                  Livraison e-commerce Paris express pour boutiques en ligne. Service livraison rapide clients avec suivi et livraison express garantie.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Livraison clients</li>
                  <li>• E-commerce rapide</li>
                  <li>• Suivi en temps réel</li>
                  <li>• Service boutique</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Processus Livraison */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Comment Fonctionne Notre Livraison Express
            </h2>
            
            <div className="grid md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold text-white">1</span>
                </div>
                <h4 className="font-bold text-lg mb-3">Appel Immédiat</h4>
                <p className="text-gray-600 text-sm">
                  Vous appelez notre service livraison express Paris au +33632410246 pour une prise en charge immédiate.
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold text-white">2</span>
                </div>
                <h4 className="font-bold text-lg mb-3">Livreur Dispatché</h4>
                <p className="text-gray-600 text-sm">
                  Notre livreur le plus proche est immédiatement dispatché vers votre adresse de collecte pour livraison express.
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold text-white">3</span>
                </div>
                <h4 className="font-bold text-lg mb-3">Collecte Rapide</h4>
                <p className="text-gray-600 text-sm">
                  Le livreur récupère votre colis et démarre immédiatement la livraison express Paris vers la destination.
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold text-white">4</span>
                </div>
                <h4 className="font-bold text-lg mb-3">Livraison Express</h4>
                <p className="text-gray-600 text-sm">
                  Livraison express Paris réalisée en 30 minutes maximum avec confirmation de remise et suivi temps réel.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Zones de Livraison */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Zones de Livraison Express Paris
            </h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3 text-orange-600">Zone Express 15 Min</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Paris 1er, 2ème, 3ème, 4ème</li>
                  <li>• Châtelet, Louvre</li>
                  <li>• République, Bastille</li>
                  <li>• Livraison express garantie</li>
                </ul>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3 text-orange-600">Zone Rapide 30 Min</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Paris 5ème à 20ème</li>
                  <li>• Montparnasse, Nation</li>
                  <li>• Belleville, Pigalle</li>
                  <li>• Livraison rapide Paris</li>
                </ul>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3 text-orange-600">Zone Proche 45 Min</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Boulogne, Neuilly</li>
                  <li>• Vincennes, Montreuil</li>
                  <li>• Issy, Levallois</li>
                  <li>• Livraison banlieue proche</li>
                </ul>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md">
                <h4 className="font-bold text-lg mb-3 text-orange-600">Zone Étendue 1H</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Hauts-de-Seine complet</li>
                  <li>• Val-de-Marne, Seine-Saint-Denis</li>
                  <li>• La Défense, Créteil</li>
                  <li>• Livraison Île-de-France</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Tarifs Livraison Express */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Tarifs Livraison Express Paris
            </h2>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-rocket-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Express 30 Min</h3>
                <div className="text-4xl font-bold text-orange-600 mb-4">15€</div>
                <ul className="text-gray-600 space-y-2 mb-6">
                  <li>• Paris centre uniquement</li>
                  <li>• Colis jusqu'à 5kg</li>
                  <li>• Livreur moto</li>
                  <li>• Garantie 30 minutes</li>
                </ul>
                <a 
                  href="tel:+33632410246"
                  className="inline-flex items-center px-6 py-3 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-700 transition-colors whitespace-nowrap"
                >
                  Commander Express
                </a>
              </div>

              <div className="bg-orange-600 p-8 rounded-2xl shadow-lg text-white text-center relative">
                <div className="absolute top-4 right-4 bg-yellow-400 text-orange-600 px-3 py-1 rounded-full text-sm font-bold">
                  POPULAIRE
                </div>
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-timer-2-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Rapide 1H</h3>
                <div className="text-4xl font-bold mb-4">25€</div>
                <ul className="space-y-2 mb-6">
                  <li>• Paris + proche banlieue</li>
                  <li>• Tous types de colis</li>
                  <li>• Moto ou utilitaire</li>
                  <li>• Livraison 1 heure</li>
                </ul>
                <a 
                  href="tel:+33632410246"
                  className="inline-flex items-center px-6 py-3 bg-white text-orange-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
                >
                  Commander Rapide
                </a>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-truck-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Utilitaire Express</h3>
                <div className="text-4xl font-bold text-orange-600 mb-4">45€</div>
                <ul className="text-gray-600 space-y-2 mb-6">
                  <li>• Toute Île-de-France</li>
                  <li>• Gros colis jusqu'à 50kg</li>
                  <li>• Camionnette équipée</li>
                  <li>• Service premium</li>
                </ul>
                <a 
                  href="tel:+33632410246"
                  className="inline-flex items-center px-6 py-3 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-700 transition-colors whitespace-nowrap"
                >
                  Commander Utilitaire
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Livraison Express */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Questions Fréquentes Livraison Express
            </h2>
            
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Qu'est-ce qui est inclus dans la livraison express Paris ?</h3>
                <p className="text-gray-600">
                  Notre service livraison express Paris inclut : collecte immédiate, transport direct sans arrêt, livreur dédié, suivi temps réel et garantie de délai.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Que se passe-t-il si la livraison express dépasse 30 minutes ?</h3>
                <p className="text-gray-600">
                  Si notre livraison express Paris dépasse les 30 minutes promises dans Paris centre, la course vous est offerte. Garantie livraison express respectée.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Puis-je suivre ma livraison express en temps réel ?</h3>
                <p className="text-gray-600">
                  Absolument ! Suivi livraison express en temps réel par SMS avec position du livreur et heure d'arrivée estimée mise à jour en permanence.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">La livraison express fonctionne-t-elle le weekend ?</h3>
                <p className="text-gray-600">
                  Oui, notre service livraison express Paris fonctionne 7j/7 y compris weekend et jours fériés avec les mêmes délais de livraison garantis.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Final */}
        <section className="py-20 bg-orange-600 text-white">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold mb-6">
              Livraison Express Paris Maintenant !
            </h2>
            <p className="text-xl mb-8 opacity-90">
              30 minutes chrono, livreur immédiat, service express garanti
            </p>
            <a 
              href="tel:+33632410246"
              className="inline-flex items-center px-8 py-4 bg-white text-orange-600 text-lg font-semibold rounded-full hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line w-5 h-5 mr-3"></i>
              +33 6 32 41 02 46
            </a>
          </div>
        </section>
      </main>
      
      <Footer />
      <WhatsAppButton />
    </div>
  );
}